<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Your Business</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../../../../assets/images/New_Icons/home-transprent-icon.svg"
              title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block" [hidden]="!pgLoad">
        <div class="row business_info_container">
          <div class="business_logo">
            <img src="../../../../../../../assets/img/users/no-logo.svg" *ngIf="!loginUserBusinessIcon">
            <img src="{{loginUserBusinessIcon}}" *ngIf="loginUserBusinessIcon">
          </div>
          <div class="business_info_details">
            <div class="business_name_div">
              <span>{{businessEntity && businessEntity.businessName}}</span>
              <br>
            </div>
            <div class="business_info">
              <div class="business_address_div">
                <span>
                  {{((businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == '' ||
                  (businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == null) ? 'NA' :
                  businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == '' ||
                  (businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == null) ? 'NA' :
                  businessEntity && businessEntity.address[0] && businessEntity.address[0].street}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == '' ||
                  (businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == null) ? 'NA' :
                  businessEntity && businessEntity.address[0] && businessEntity.address[0].city}}
                </span>
              </div>
              <div class="business_email_div">
                <img src="../../../../../../../assets/images/New_Icons/email-icon.svg">
                <span>{{businessEntity && businessEntity.email == '' || businessEntity && businessEntity.email == null ?
                  'NA' : businessEntity && businessEntity.email}}</span>
              </div>
              <div class="business_mobile_number_div">
                <img src="../../../../../../../assets/images/New_Icons/mobile-icon.svg">
                <span>{{businessEntity && businessEntity.dialingCode}} {{businessEntity && businessEntity.mobileNumber
                  }}</span>
              </div>
              <div class="business_type_div">
                <img src="../../../../../../../assets/images/New_Icons/company-name-icon.svg">
                <span>{{businessEntity && businessEntity.businessType[0] && businessEntity.businessType[0].name}}</span>
              </div>
              <div class="business_type_div" *ngIf="['Farmer', 'Business Admin'].includes(loginPersonType)">
                <img src="../../../../../../../assets/images/New_Icons/delete.svg"
                  (click)="navigateToAccountClosurePopupOpenScreen(businessEntity)" style="cursor: pointer;">
                <span style="color: red;">Account Closure</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="!pgLoad">
          <div class="search_cum_icons_button_container">
            <div class="gap"></div>
            <div class="add-button-container" (click)="openForm()">
              <button class="button">
                <span class="icon"><img src="../../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
                <span class="text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div class="cards_container">
          <div class="card_wrapper" *ngFor="let eachaactivedocdata of farmSitesList">
            <div class="each_card_div">
              <div class="card_content">
                <div class="card_header">
                  <div class="img_cum_business_name_div">
                    <img src="../../../../../../../assets/images/New_Icons/card-heading.svg">
                    <span title="{{eachaactivedocdata && eachaactivedocdata.farmNameAtLocation}}">
                      {{eachaactivedocdata && eachaactivedocdata.farmNameAtLocation.slice(0, 15)}}<span
                        *ngIf="eachaactivedocdata && eachaactivedocdata.farmNameAtLocation.length > 15">...</span>
                    </span>
                    <span class="business_type_heading"></span>
                  </div>
                </div>
                <div class="card_body">
                  <div>
                    <img src="../../../../../../../assets/images/New_Icons/location-card-icon.svg">
                    <span>{{eachaactivedocdata && eachaactivedocdata.address &&
                      eachaactivedocdata.address.village}}</span>
                  </div>
                  <div>
                    <img src="../../../../../../../assets/images/New_Icons/address-card-icon.svg">
                    <span class="description">{{eachaactivedocdata && eachaactivedocdata.address &&
                      eachaactivedocdata.address.district}}</span>
                  </div>
                </div>
              </div>
              <div class="card_footer">
                <div class="separate_field">
                  <span class="field_text">Ownership: </span>
                  <span class="field_value_text">{{((eachaactivedocdata && eachaactivedocdata.ownership) == '' ||
                    (eachaactivedocdata && eachaactivedocdata.ownership) == null) ? 'NA' : eachaactivedocdata &&
                    eachaactivedocdata.ownership}}</span>
                </div>
                <div class="activities_icons">
                  <a>
                    <img src="../../../../../../../assets/images/New_Icons/edit.svg" title="Edit Farmsite"
                      class="activities_images" (click)="farmSiteDetailsByID(eachaactivedocdata.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12" *ngIf=" farmSites && farmSites.length == 0" style="margin-top: 20px;">
          <h1>No Data</h1>
        </div>
      </div>

      <div class="dynamic-form-wrapper" [ngClass]="{
            'floating-panel': formFieldCount <= 7,
            'slide-in-overlay': formFieldCount > 7
          }" *ngIf="showForm">

        <div *ngIf="formFieldCount > 7" class="overlay-background" (click)="cancel()"></div>

        <div class="popup-wrapper">

          <button type="button" class="popup-close-beside" (click)="cancel()" title="Close">
            &times;
          </button>

          <!-- Actual Popup -->
          <div [ngClass]="{
              'form-container-panel': formFieldCount > 7,
              'popup-inner': formFieldCount <= 7
            }">

            <form [formGroup]="addFarmsiteForm" novalidate>
              <!-- Title -->

              <div class="form-header">
                <div class="form-title">Location</div>
                <button class="add-update-submit-button" (click)="submitButton ? addFarmSite() : updateFarmSite()"
                  [disabled]="locationCreationDoubleClick">
                  <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update'}}</span>
                </button>
              </div>

              <div class="form-container" (clickOutside)="closeAllDropdowns()">

                <!-- === Section: Farm Location Details === -->
                <div class="form-section">
                  <div class="grid-three-cols">
                    <!-- ───────── LOCATION NAME ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Location Name</mat-label>
                      <input matInput id="locationname" autocomplete="off" placeholder=""
                        formControlName="farmNameAtLocation" [(ngModel)]="farmSite.farmNameAtLocation" />

                      <mat-hint>
                        <i>3-30 alphabetic characters</i>
                      </mat-hint>

                      <mat-error *ngIf="(submitted || f.farmNameAtLocation.touched || f.farmNameAtLocation.dirty)">
                        <ng-container *ngIf="f.farmNameAtLocation.hasError('required')">Required.</ng-container>
                        <ng-container *ngIf="f.farmNameAtLocation.hasError('minlength')">Minimum 3 characters
                          required.</ng-container>
                        <ng-container *ngIf="f.farmNameAtLocation.hasError('maxlength')">Maximum 30 characters
                          allowed.</ng-container>
                        <ng-container *ngIf="f.farmNameAtLocation.hasError('pattern')">Numbers not
                          allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>
                    <!-- ───────── OWNERSHIP ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Ownership</mat-label>
                      <mat-select id="ownership" formControlName="ownership" [(ngModel)]="farmSite.ownership">
                        <mat-option value="undefined" disabled>Select Ownership</mat-option>
                        <mat-option value="Owned">Owned</mat-option>
                        <mat-option value="Leased">Leased</mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f.ownership.invalid">
                        <i>Select ownership as Owned or leased</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.ownership.valid">
                        <i>Selected ownership as {{ farmSite.ownership }}</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.ownership.touched || f.ownership.dirty) && f.ownership.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>
                    <!-- ───────── YEAR STARTED ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Year Started</mat-label>
                      <mat-select id="yearstarted" formControlName="yearStarted" [(ngModel)]="farmSite.yearStarted">
                        <mat-option value="undefined" disabled>Select Year</mat-option>
                        <mat-option *ngFor="let year of yearStartedArr" [value]="year">
                          {{ year }}
                        </mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f.yearStarted.invalid">
                        <i>Select year</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.yearStarted.valid">
                        <i>Year selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.yearStarted.touched || f.yearStarted.dirty) && f.yearStarted.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>
                    <!-- ――――――――――――――  Total Farm Area (ha)  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Area (ha)</mat-label>

                      <input matInput id="area" type="text" formControlName="totalFarmArea" autocomplete="off"
                        placeholder="Enter total farm area" [(ngModel)]="farmSite.totalFarmArea"
                        (keypress)="numberValidation($event)"
                        (click)="isCountryDropdown = false; isVillageDropdown = false; isStateDropdown = false" />

                      <!-- Optional hint -->
                      <mat-hint><i>Numbers only, in hectares</i></mat-hint>

                      <!-- Error block -->
                      <mat-error *ngIf="
                          (f.totalFarmArea.dirty || f.totalFarmArea.touched || submitted) &&
                          f.totalFarmArea.errors
                        ">
                        <i>
                          {{
                          f.totalFarmArea.hasError('required')
                          ? 'Total farm area is required.'
                          : f.totalFarmArea.hasError('pattern')
                          ? 'Enter numbers only.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                    <!-- ――――――――――――――  Water Spread Area (ha)  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Water Spread Area (ha)</mat-label>

                      <input matInput type="text" id="waterspread" formControlName="waterspreadArea" autocomplete="off"
                        [(ngModel)]="farmSite.waterSpreadArea" (keypress)="numberValidation($event)"
                        (change)="changewaterspreadare()"
                        (click)="isCountryDropdown = false; isVillageDropdown = false; isStateDropdown = false"
                        placeholder="Enter water spread area" />

                      <mat-hint><i>Decimal values allowed</i></mat-hint>

                      <mat-error
                        *ngIf="(f.waterspreadArea.dirty || f.waterspreadArea.touched || submitted) && f.waterspreadArea.errors">
                        <i>
                          {{
                          f.waterspreadArea.hasError('required')
                          ? 'Water spread area is required.'
                          : f.waterspreadArea.hasError('pattern')
                          ? 'Enter valid number.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                    <!-- ――――――――――――――  No. of Growout Ponds  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>No. of Growout Ponds</mat-label>

                      <input matInput type="text" id="Growout" formControlName="numberOfGrowoutPonds" autocomplete="off"
                        [(ngModel)]="farmSite.numberOfGrowoutPonds" (keypress)="numberValidation($event)"
                        (click)="isCountryDropdown = false; isVillageDropdown = false; isStateDropdown = false"
                        placeholder="Enter number" />

                      <mat-hint><i>Only numeric values allowed</i></mat-hint>

                      <mat-error
                        *ngIf="(f.numberOfGrowoutPonds.dirty || f.numberOfGrowoutPonds.touched || submitted) && f.numberOfGrowoutPonds.errors">
                        <i>
                          {{
                          f.numberOfGrowoutPonds.hasError('required')
                          ? 'Growout ponds count is required.'
                          : f.numberOfGrowoutPonds.hasError('pattern')
                          ? 'Enter numbers only.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                    <!-- ――――――――――――――  No. of Nurseries  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>No. of Nurseries</mat-label>

                      <input matInput type="text" id="Nurseries" formControlName="numberOfNurseries" autocomplete="off"
                        [(ngModel)]="farmSite.numberOfNurseries" (keypress)="numberValidation($event)"
                        (click)="isCountryDropdown = false; isVillageDropdown = false; isStateDropdown = false"
                        placeholder="Enter number" />

                      <mat-hint><i>Only numeric values allowed</i></mat-hint>

                      <mat-error
                        *ngIf="(f.numberOfNurseries.dirty || f.numberOfNurseries.touched || submitted) && f.numberOfNurseries.errors">
                        <i>
                          {{
                          f.numberOfNurseries.hasError('required')
                          ? 'Nursery count is required.'
                          : f.numberOfNurseries.hasError('pattern')
                          ? 'Enter numbers only.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Address Details === -->
                <div class="form-section">
                  <h3 class="section-title">Address Details</h3>
                  <div class="grid-three-cols">
                    <!-- ───────── COUNTRY ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Country Selection</mat-label>
                      <input matInput id="country" autocomplete="off" formControlName="countryName"
                        [matAutocomplete]="autoCountry" (focus)="filteredCountriesList=countries"
                        (keyup)="filterCountries($event)" />

                      <mat-autocomplete #autoCountry="matAutocomplete"
                        (optionSelected)="coutrySelection($event.option.value)">
                        <mat-option *ngFor="let c of filteredCountriesList" [value]="c">
                          {{ c.name }}
                        </mat-option>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f.countryName.invalid">
                        <i>Select country</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.countryName.valid">
                        <i>Country selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.countryName.touched || f.countryName.dirty) && f.countryName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>
                    <!-- ───────── STATE ───────── -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                      <mat-label>State Selection</mat-label>
                      <input matInput id="state" autocomplete="off" formControlName="stateName"
                        [matAutocomplete]="autoState" [disabled]="stateVillageDisabled"
                        (focus)="filteredStatesList=states" (keyup)="filterStates($event)" />

                      <mat-autocomplete #autoState="matAutocomplete"
                        (optionSelected)="stateSelection($event.option.value)">
                        <mat-option *ngFor="let s of filteredStatesList" [value]="s">
                          {{ s.name }}
                        </mat-option>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f.stateName.invalid">
                        <i>Select state</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.stateName.valid">
                        <i>State selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.stateName.touched || f.stateName.dirty) && f.stateName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>
                    <!-- ───────── VILLAGE ───────── -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                      <mat-label>Village Selection</mat-label>

                      <input matInput id="village" autocomplete="off" formControlName="villageName"
                        [matAutocomplete]="autoVillage" [disabled]="stateVillageDisabled || isLoadingVillages"
                        (keyup)="filterVillages($event)" (focus)="onVillageFocus()" (blur)="onVillageBlur()"
                        #autoTrigger="matAutocompleteTrigger" />

                      <!-- Loader while fetching API -->
                      <mat-spinner *ngIf="isLoadingVillages" diameter="20" class="absolute right-2 top-2"></mat-spinner>

                      <mat-autocomplete #autoVillage="matAutocomplete" panelClass="village-panel">
                        <!-- Error message if API fails -->
                        <mat-option *ngIf="villagesLoadError" disabled>
                          Villages fetching failed. Reselect state to retry.
                        </mat-option>

                        <!-- No data found message -->
                        <mat-option *ngIf="noDataFound" disabled>
                          No data found
                        </mat-option>

                        <!-- Virtual Scroll Container -->
                        <cdk-virtual-scroll-viewport itemSize="48" style="height: 250px;"
                          [style.height.px]="visibleVillages.length < CHUNK_SIZE ? visibleVillages.length * 48 : 250"
                          (scrolledIndexChange)="onVillageScroll()" [minBufferPx]="500" [maxBufferPx]="1000">
                          <div *cdkVirtualFor="let v of visibleVillages; let i = index">
                            <mat-option [value]="v.city_town_village_name" (click)="villageSelection(v)">
                              {{ v.city_town_village_name }}
                            </mat-option>
                          </div>

                          <!-- Loader inside scroll -->
                          <div class="loader-section" *ngIf="isLoadingMore">
                            <mat-spinner diameter="20"></mat-spinner>
                            <span>Loading more...</span>
                          </div>
                        </cdk-virtual-scroll-viewport>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f.villageName.invalid"><i>Select village</i></mat-hint>
                      <mat-hint *ngIf="f.villageName.valid"><i>Village selected</i></mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.villageName.touched || f.villageName.dirty) && f.villageName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>

                  </div>
                </div>

                <!-- === Section: Water & Soil Information === -->
                <div class="form-section">
                  <h3 class="section-title">Water & Soil Information</h3>
                  <div class="grid-three-cols">
                    <!-- ――――――――――――――  Water Type  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Water Type</mat-label>

                      <mat-select id="qptype" formControlName="waterTypeId" [(ngModel)]="waterType.waterTypeId"
                        placeholder="Select Water Type">
                        <mat-option disabled selected value="undefined">Select Water Type</mat-option>
                        <mat-option *ngFor="let type of waterTypes" [value]="type.id">
                          {{ type.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint><i>Select the applicable water source</i></mat-hint>

                      <mat-error *ngIf="(f.waterTypeId.touched || submitted) && f.waterTypeId.errors">
                        <i>
                          {{
                          f.waterTypeId.hasError('required')
                          ? 'Water type is required.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                    <!-- ――――――――――――――  Soil Type  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Soil Type</mat-label>

                      <mat-select id="category" formControlName="soilTypeId" [(ngModel)]="soilType.soilTypeId"
                        placeholder="Select Soil Type">
                        <mat-option disabled selected value="undefined">Select Soil Type</mat-option>
                        <mat-option *ngFor="let category of soilTypes" [value]="category.id">
                          {{ category.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint><i>Choose the soil category</i></mat-hint>

                      <mat-error *ngIf="(f.soilTypeId.touched || submitted) && f.soilTypeId.errors">
                        <i>
                          {{
                          f.soilTypeId.hasError('required')
                          ? 'Soil type is required.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Bio-Security in the Farm === -->
                <div class="form-section">
                  <h3 class="section-title">Bio-Security in the Farm</h3>
                  <!-- ――――――――――――――  Bio-Security in the Farm ―――――――――――――― -->
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <mat-checkbox formControlName="bioFencing" [(ngModel)]="bioFencing" name="fencing">
                          Fencing
                        </mat-checkbox>
                      </div>

                      <div class="col-md-6 mb-2">
                        <mat-checkbox formControlName="bioHWandFA" [(ngModel)]="bioHWandFA" name="hwandfa">
                          Hand Wash and Footbath Area
                        </mat-checkbox>
                      </div>

                      <div class="col-md-6 mb-2">
                        <mat-checkbox formControlName="bioCrabFencing" [(ngModel)]="bioCrabFencing" name="crab">
                          Crab Fencing
                        </mat-checkbox>
                      </div>

                      <div class="col-md-6 mb-2">
                        <mat-checkbox formControlName="bioReservoirs" [(ngModel)]="bioReservoirs" name="reservoirs">
                          Reservoirs
                        </mat-checkbox>
                      </div>

                      <div class="col-md-6 mb-2">
                        <mat-checkbox formControlName="bioBirdFencing" [(ngModel)]="bioBirdFencing" name="birdfencing">
                          Bird Fencing
                        </mat-checkbox>
                      </div>

                      <div class="col-md-6 mb-2">
                        <mat-checkbox formControlName="bioFilters" [(ngModel)]="bioFilters" name="filters">
                          Filters
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- === Section: Provider Technician (Only for Business Admin & Provider) === -->
                <div class="form-section"
                  *ngIf="loginPersonType === 'Business Admin' && loginUserBusinessCategory === 'Provider'">
                  <h3 class="section-title">Provider Technician</h3>
                  <div class="grid-three-cols">
                    <mat-form-field appearance="outline" class="w-100" style="margin-top: 20px">
                      <mat-label>Provider Technician</mat-label>

                      <mat-select id="batech" [(ngModel)]="feedProviderPersonId" formControlName="providertech"
                        placeholder="Select Provider Technician">
                        <mat-option value="undefined" disabled selected>Select Provider Technician</mat-option>
                        <mat-option *ngFor="let person of businessAdminPersons" [value]="person.id">
                          {{ person.firstName }} ({{ person.personType[0].name }})
                        </mat-option>
                      </mat-select>

                      <mat-hint><i>Select the technician for this provider</i></mat-hint>

                      <mat-error *ngIf="(f.providertech.touched || submitted) && f.providertech.errors">
                        <i>
                          {{
                          f.providertech.hasError('required')
                          ? 'Provider technician is required.'
                          : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Provider or SME Configuration === -->
                <div class="form-section" *ngIf="loginUserBusinessCategory === 'Farm'">
                  <h3 class="section-title">Provider or SME Configuration</h3>
                  <!-- ―――――――――――――― Enable/Disable Provider/SME ―――――――――――――― -->
                  <div class="enable-provider-sme">
                    <mat-checkbox formControlName="enablesme" [(ngModel)]="isSMEChecked"
                      (change)="enableDisableProviderOrSME()" name="enablesme">
                      Enable/Disable Provider/SME
                    </mat-checkbox>
                  </div>
                  <!-- ―――――――――――――― Provider or SME Radio Selection ―――――――――――――― -->
                  <div *ngIf="(loginPersonType === 'Business Admin' && loginUserBusinessCategory !== 'Provider') || (loginPersonType !== 'Business Admin' && loginUserBusinessCategory !== 'Provider')
                    && isSMEChecked
                    ">
                    <mat-radio-group aria-label="Select Provider or SME" formControlName="providerOrSme"
                      [(ngModel)]="providerOrSme" (change)="providerOrSmeChange()">
                      <mat-radio-button [value]="true" class="mr-4">Provider</mat-radio-button>
                      <mat-radio-button [value]="false">SME</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <!-- Provider Contract Details -->
                  <div *ngIf="isProviderSelected" style="margin-top: 1.5rem;">
                    <div class="form-section">
                      <div class="grid-three-cols">
                        <!-- Feed/Seed Provider (Business) -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Business</mat-label>
                            <mat-select id="provider" [(ngModel)]="contract.feedProviderID"
                              formControlName="providerBusinessId"
                              (selectionChange)="getProviderPersonsByBusinessID(contract.feedProviderID)"
                              placeholder="Select Business">
                              <mat-option value="undefined" disabled>Select Business</mat-option>
                              <mat-option *ngFor="let fprovider of providerBusinessEntities" [value]="fprovider.id">
                                {{ fprovider.businessName }}
                              </mat-option>
                            </mat-select>

                            <mat-error *ngIf="providerOrSme && !contract.feedProviderID">
                              <i>Required</i>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <!-- Person -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Person</mat-label>
                            <mat-select id="providerperson" [(ngModel)]="contract.feedProviderPersonID"
                              formControlName="providerPersonId" placeholder="Select Person">
                              <mat-option value="undefined" disabled>Select Person</mat-option>
                              <mat-option *ngFor="let person of providerPersons" [value]="person.id">
                                {{ person.firstName }}
                              </mat-option>
                            </mat-select>

                            <mat-error *ngIf="providerOrSme && !contract.feedProviderPersonID">
                              <i>Required</i>
                            </mat-error>


                          </mat-form-field>
                          <p style="color: red; margin-top: -30px; margin-left: 6px;" *ngIf="
                              providerPersons &&
                              providerPersons.length === 0 &&
                              contract.feedProviderID !== '' &&
                              isSMEChecked
                            ">
                            No Provider Person found for this business
                          </p>
                        </div>
                        <!-- Chatty -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Chatty</mat-label>
                            <mat-select id="providerchartuser" [(ngModel)]="farmSite.providerUserConfig"
                              formControlName="providerChatUserConfig" placeholder="Select Chatty">
                              <mat-option value="undefined" disabled>Select Chatty</mat-option>
                              <mat-option *ngFor="let person of personsByProviderBusinessId" [value]="person.id">
                                {{ person.firstName }} ({{ person.personType[0].name }})
                              </mat-option>
                            </mat-select>

                            <mat-error *ngIf="providerOrSme && farmSite.providerUserConfig?.length === 0">
                              <i>Required</i>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- SME Contract Details -->
                  <div *ngIf="isSmeSElected" style="margin-top: 1.5rem;">
                    <div class="form-section">
                      <div class="grid-three-cols">
                        <!-- SME Business -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Business</mat-label>

                            <mat-select id="businessId" [(ngModel)]="smeContract.SMEBusinessID"
                              formControlName="businessId"
                              (selectionChange)="getSMEPersonsByBusinessID(smeContract.SMEBusinessID)"
                              placeholder="Select Business">
                              <mat-option value="undefined" disabled>Select Business</mat-option>
                              <mat-option *ngFor="let farmprovider of smeBusinessEntities" [value]="farmprovider.id">
                                {{ farmprovider.businessName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- SME Person -->
                        <!-- 👇 wrap the person field and message in a div column -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Person</mat-label>

                            <mat-select id="person" [(ngModel)]="smeContract.SMEPersonID" formControlName="personId"
                              placeholder="Select Person">

                              <mat-option value="undefined" disabled>Select Person</mat-option>
                              <mat-option *ngFor="let person of persons" [value]="person.id">
                                {{ person.firstName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <!-- 👇 this p is now inside same column so it aligns perfectly -->
                          <p *ngIf="persons?.length === 0 && smeContract.SMEBusinessID && isSMEChecked"
                            style="color: red; font-size: 13px; margin-top: -30px; margin-left: 6px;">
                            No SME Person found for this business
                          </p>
                        </div>
                        <div class="w-100">
                          <!-- Chatty -->
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Chatty</mat-label>

                            <mat-select id="chartuser" [(ngModel)]="farmSite.chatUserConfig"
                              formControlName="chatUserConfig" placeholder="Select Chatty">
                              <mat-option value="undefined" disabled>Select Chatty</mat-option>
                              <mat-option *ngFor="let person of personsByBusinessId" [value]="person.id">
                                {{ person.firstName }} ({{ person.personType[0].name }})
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div formGroupName="SMEDateRangeForm">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Date Range</mat-label>

                            <mat-date-range-input [rangePicker]="picker">
                              <input matStartDate placeholder="Start date" formControlName="start" readonly />
                              <input matEndDate placeholder="End date" formControlName="end" readonly />
                            </mat-date-range-input>

                            <button mat-icon-button matSuffix (click)="picker.open()" aria-label="Toggle date"
                              style="z-index:1000; position:relative; background:none; border:none; box-shadow:none; outline:none;">
                              <mat-icon>calendar_today</mat-icon>
                            </button>

                            <mat-date-range-picker #picker (closed)="smeOnPickerClosed()"></mat-date-range-picker>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- === Section: Buyer Contract Details === -->
                <div class="form-section" *ngIf="loginUserBusinessCategory === 'Farm'">
                  <h3 class="section-title">Buyer Contract Details</h3>

                  <div class="enable-buyer" *ngIf="loginUserBusinessCategory === 'Farm'">
                    <mat-checkbox formControlName="enablebuyer" [(ngModel)]="isBuyerChecked" name="enablebuyer"
                      (change)="enableDisableBuyer()">
                      Enable/Disable Buyer
                    </mat-checkbox>
                  </div>

                  <div *ngIf="isBuyerChecked">
                    <div class="form-section">
                      <div class="grid-three-cols">
                        <!-- Buyer Business -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100"
                            *ngIf="loginUserBusinessCategory === 'Farm'">
                            <mat-label>Business</mat-label>

                            <mat-select id="buyerbusinessId" [(ngModel)]="buyerContract.buyerBusinessID"
                              formControlName="buyerbusinessId"
                              (selectionChange)="getBuyerPersonsByBusinessID(buyerContract.buyerBusinessID)"
                              placeholder="Select Business">
                              <mat-option value="undefined" disabled>Select Business</mat-option>
                              <mat-option *ngFor="let farmprovider of buyerBusinessEntities" [value]="farmprovider.id">
                                {{ farmprovider.businessName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Buyer Person -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100"
                            *ngIf="loginUserBusinessCategory === 'Farm'">
                            <mat-label>Buyer</mat-label>

                            <mat-select id="buyerPerson" [(ngModel)]="buyerContract.buyerPersonID"
                              formControlName="buyerPersonId" placeholder="Select Buyer">
                              <mat-option value="undefined" disabled>Select Buyer</mat-option>
                              <mat-option *ngFor="let person of buyerPersons" [value]="person.id">
                                {{ person.firstName }}
                              </mat-option>
                            </mat-select>

                            <!-- No-buyer warning -->

                          </mat-form-field>
                          <p style="color: red; margin-top: -30px; margin-left: 6px;" *ngIf="
                              buyerPersons && buyerPersons.length === 0 &&
                              buyerContract.buyerBusinessID !== '' && isBuyerChecked
                            ">
                            No Buyer Person found for this business
                          </p>
                        </div>
                        <!-- Chatty -->
                        <div class="w-100">
                          <mat-form-field appearance="outline" class="w-100"
                            *ngIf="loginUserBusinessCategory === 'Farm'">
                            <mat-label>Chatty</mat-label>

                            <mat-select id="buyerUserConfig" [(ngModel)]="farmSite.buyerUserConfig"
                              formControlName="buyerUserConfig" placeholder="Select Chatty">
                              <mat-option value="undefined" disabled>Select Chatty</mat-option>
                              <mat-option *ngFor="let person of personsByBusinessId" [value]="person.id">
                                {{ person.firstName }} ({{ person.personType[0].name }})
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div formGroupName="BuyerDateRangeForm">
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Date Range</mat-label>

                            <mat-date-range-input [rangePicker]="picker">
                              <input matStartDate placeholder="Start date" formControlName="start" readonly />
                              <input matEndDate placeholder="End date" formControlName="end" readonly />
                            </mat-date-range-input>

                            <button mat-icon-button matSuffix (click)="picker.open()" aria-label="Toggle date"
                              style="z-index:1000; position:relative; background:none; border:none; box-shadow:none; outline:none;">
                              <mat-icon>calendar_today</mat-icon>
                            </button>

                            <mat-date-range-picker #picker (closed)="buyerOnPickerClosed()"></mat-date-range-picker>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- === Section: On-Premises Facilities === -->
                <div class="form-section">
                  <h3 class="section-title">On-Premises Facilities</h3>
                  <div class="grid-two-cols">
                    <!-- ―――――――――――――― ETS on Premises ―――――――――――――― -->
                    <div class="top-field">
                      <p class="mb-2">ETS on premises</p>
                      <mat-radio-group name="ETSOnPremises" [(ngModel)]="farmSite.ETSOnPremises"
                        formControlName="ETSOnPremises" class="d-flex gap-4">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                      </mat-radio-group>
                    </div>

                    <!-- ―――――――――――――― Lab on Premises ―――――――――――――― -->
                    <div class="top-field">
                      <p class="mb-2">Lab on premises</p>
                      <mat-radio-group name="labOnPremises" [(ngModel)]="farmSite.labOnPremises"
                        formControlName="labOnPremises" class="d-flex gap-4">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>